import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { NavMenuItem } from 'views/rebranded-module/common/components/Logical/LayoutV2/NavBar';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  '& .UNContainer': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
    },
  },
  '& .UNDivider': {
    height: theme.spacing(1),
    backgroundColor: theme.palette.divider[8],
    color: theme.palette.divider[8],
    margin: 'auto 0 !important',
  },
}));

export const StyledNavMenuItem = styled(NavMenuItem)(({ theme }) => ({
  padding: theme.spacing(1, 1.75),
  '& .NMIIcon': {
    position: 'relative',
    top: theme.spacing(-0.25),
  },
  '& .NMILable': {
    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(1.75),
    },
  },
  '&.UNCompanyBtn': {
    '& .NMILable': {
      [theme.breakpoints.down('md')]: {
        maxWidth: theme.spacing(15),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
  },
}));

export default StyledBox;
